const CardVerifyIcon = () => {
  return (
    <svg width='62' height='62' viewBox='0 0 62 62' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.1912 9.70901C15.4976 4.4693 20.8043 1.28073 26.044 2.58714L52.1342 9.09215C57.3739 10.3986 60.5624 15.7052 59.256 20.9449L52.751 47.0351C51.4446 52.2748 46.1379 55.4634 40.8982 54.157L14.808 47.652C9.56834 46.3456 6.37976 41.0389 7.68617 35.7992L14.1912 9.70901Z'
        fill='url(#paint0_linear_4911_1780)'
      />
      <g filter='url(#filter0_bi_4911_1780)'>
        <path
          d='M0.666016 24.6655C0.666016 19.2654 5.04368 14.8877 10.4438 14.8877H37.3327C42.7328 14.8877 47.1105 19.2654 47.1105 24.6655V51.5544C47.1105 56.9545 42.7328 61.3321 37.3327 61.3321H10.4438C5.04368 61.3321 0.666016 56.9545 0.666016 51.5544V24.6655Z'
          fill='url(#paint1_linear_4911_1780)'
          fillOpacity='0.5'
        />
      </g>
      <path
        d='M21.2732 45.1001C20.7794 45.1001 20.2855 44.9127 19.9085 44.5357L14.6768 39.304C13.9228 38.55 13.9228 37.3286 14.6768 36.5768C15.4308 35.8228 16.65 35.8206 17.404 36.5746L21.2732 40.4438L30.3742 31.3428C31.1282 30.5888 32.3474 30.5888 33.1014 31.3428C33.8554 32.0968 33.8554 33.3182 33.1014 34.0722L22.6379 44.5357C22.2609 44.9127 21.7671 45.1001 21.2732 45.1001'
        fill='white'
        fillOpacity='0.9'
      />
      <defs>
        <filter
          id='filter0_bi_4911_1780'
          x='-8.22287'
          y='5.99881'
          width='64.2231'
          height='64.2221'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='4.44444' />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_4911_1780' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_4911_1780' result='shape' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='0.444444' dy='0.222222' />
          <feGaussianBlur stdDeviation='1.11111' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend mode='normal' in2='shape' result='effect2_innerShadow_4911_1780' />
        </filter>
        <linearGradient
          id='paint0_linear_4911_1780'
          x1='61.6215'
          y1='11.4576'
          x2='8.60312'
          y2='49.8226'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00D82F' />
          <stop offset='1' stopColor='#2FA7CD' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4911_1780'
          x1='-1.75202'
          y1='65.2025'
          x2='64.4452'
          y2='46.8202'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#45CAF4' />
          <stop offset='1' stopColor='#00D82F' />
        </linearGradient>
      </defs>
    </svg>
  )
}
export default CardVerifyIcon
